import { t } from "i18next";
import { Button, Icon } from "@livingmap/hippo";

import styles from "./Modal.module.scss";

interface Props {
  closeModal: () => void;
  onUnarchive: () => void;
}

const Unarchive: React.FC<Props> = ({ closeModal, onUnarchive }) => {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <h5 className={styles.title}>{t("modals.unarchive.title")}</h5>
        <button className={styles.closeButton} onClick={closeModal}>
          <Icon dataQA="close-icon" name="close" size={18} />
        </button>
      </div>
      <div className={styles.contentContainer}>
        <p className={styles.description}>
          {t("modals.unarchive.description")}
        </p>
        <div className={styles.buttonWrapper}>
          <Button
            dataQA="cancel-button"
            type="primary"
            size="regular"
            style="filled"
            text={t("btn_labels.cancel")}
            onClick={closeModal}
          />
          <Button
            dataQA="delete-button"
            type="negative"
            size="regular"
            style="filled"
            text={t("modals.unarchive.btn_labels.unarchive")}
            onClick={onUnarchive}
          />
        </div>
      </div>
    </div>
  );
};

export default Unarchive;
